import { CheckboxProps, Flex, FlexProps, useCheckbox } from '@chakra-ui/react';
import {
  getCheckButtonBg as getBg,
  getCheckButtonColor as getColor,
} from 'utils';

const CustomCheckButton = (
  props: CheckboxProps & { flex?: FlexProps },
): JSX.Element => {
  const { state, getInputProps } = useCheckbox(props);
  const input = getInputProps();
  return (
    <Flex
      as="label"
      cursor="pointer"
      direction="column"
      alignItems="center"
      justifyContent="center"
      bg={getBg(state.isChecked)}
      color={getColor(state.isChecked)}
      sx={{ transition: 'all 0.2s ease-in-out' }}
      borderWidth="1px"
      borderColor="input.gray"
      borderRadius="100px"
      whiteSpace="nowrap"
      py={4}
      px={6}
      {...props.flex}
    >
      <input {...input} />
      {props.children}
    </Flex>
  );
};

export default CustomCheckButton;
